<template>
  <section class="add-locations">
    <div class="header-row">
      <div>
        <h2 class="title">
          Add Locations and Users
          <VideoHoverPlayer title="License Our Courses" videoUrl="https://player.vimeo.com/video/334440078?autoplay=1" />
        </h2>
      </div>
      <div class="step-badge">Step 3/5</div>
    </div>

    <div class="form-row">
      <div class="field">
        <label># of Locations <span class="required">*</span></label>
        <input
          type="number"
          v-model="locations"
          placeholder="Enter the Number of Locations"
        />
      </div>
      <div class="field">
        <label>Estimated # of Users <span class="required">*</span></label>
        <input
          type="number"
          v-model="users"
          placeholder="Enter your Estimated number of Users"
        />
      </div>

    </div>

    <div class="cta-row">
      <button class="next-btn" @click="handleNextStep" :disabled="!isValid">
        Next Step
      </button>
    </div>
  </section>
</template>

<script>

import VideoHoverPlayer from "@/components/Signup/VideoHoverPlayer.vue";
export default {
  name: "AddLocations",
  components: { VideoHoverPlayer },
  data() {
    return {
      locations: null,
      users: null,
    };
  },
  computed: {
    isValid() {
      return this.locations > 0 && this.users > 0;
    },
  },
  methods: {
    handleNextStep() {
      if (this.isValid) {
        this.$emit("locations-added", {
          locations: parseInt(this.locations),
          users: parseInt(this.users),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.add-locations {
  background: transparent;
  padding: 8px 0 0 0;
  position: relative;
}
.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.title {
  font-size: 20px;
  line-height: 25px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #252525;
  display: flex;
  align-items: center;
  .play-icon {
    display: none;
  }
}

.step-badge {
  position: absolute;
  right: 0;
  top: 0;
  background: #fff0ea;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 10px;
  line-height: 23px;
  font-weight: 700;
  color: #252525;
}
.form-row {
  display: flex;
  gap: 20px;
  flex-direction: column;
  .field {
    display: flex;
    flex-direction: column;
    label {
      font-weight: 700;
      margin-bottom: 8px;
      font-size: 12px;
      line-height: 15px;
    }
    .required {
      color: #ff6a4a;
      margin-left: 6px;
    }
    input {
      height: 48px;
      padding: 12px 14px;
      border-radius: 10px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      background: #fff;
      outline: none;
      font-size: 14px;
    }
  }
}

.cta-row {
  margin-top: 22px;
  .next-btn {
    width: 100%;
    padding: 16px 20px;
    border-radius: 12px;
    background: linear-gradient(90deg, #ff8a56 0%, #ff4a36 100%);
    color: #fff;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    border: none;
    cursor: pointer;
  }
}
// Responsive Styles
@media (min-width: 768px) {
  .add-locations {
    margin-top: 60px;
  }
  .title {
    font-size: 32px;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 20px;
    .play-icon {
      color: #eb1a26;
      margin-left: 10px;
      font-size: 24px;
      display: block;
    }
  }

  .step-badge {
    top: 0;
    padding: 10px 14px;
    border-radius: 16px;
    font-size: 18px;
  }
  .form-row {
    flex-direction: row;
    .field {
      flex: 1 1 0;
      label {
        font-size: 15px;
        line-height: 19px;
        font-weight: 700;
        margin-bottom: 8px;
      }
    }
  }
  .cta-row {
    margin-top: 22px;
    .next-btn {
      width: 100%;
      padding: 16px 20px;
      border-radius: 12px;
    }
  }
}
</style>
